<template>
	<div class="container">
		<myHeader></myHeader>
		<div class="main">
			<div class="article-detail">

				<div class="title">
					{{ articleData.articleTitle }}
				</div>
				<div class="info">
					<span>{{ articleData.articlePublishTime }}</span>
					<span>来源：{{ articleData.articleRemarks }}</span>
				</div>
				<div class="content" v-html="articleData.articleContent"></div>
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>
</template>

<script>
	import {
		ref,
		defineComponent
	} from 'vue'
	import {
		useRoute
	} from 'vue-router'
	import {
		ElMessage
	} from 'element-plus'
	import { getArticleDetail } from '@/axios/api'
	import myHeader from '@/components/layouts/myHeader'
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	export default defineComponent({
		components: {
			myHeader,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {
			const route = useRoute();
			const articleData = ref('');
			(function getData() {
				getArticleDetail('/cdMapApi/api/article/detail/' + route.query.articleId, {
					
				}).then(function (res){
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						// 当前渲染数据列表
						articleData.value = data
						
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			})();
			
			return {
				articleData
			}
		}
	})
</script>

<style lang="scss">
	.container {
		height: auto;
		min-height: 100vh;
		margin: 0;
		padding: 0;

		.main {
			.article-detail {
				background: #fff;
				padding: 15px;

				.title {
					line-height: 25px;
					font-size: 18px;
					font-weight: bold;
					text-align: center;
					color: #333;
					border-bottom: #c1c1c1 1px solid;
					padding-bottom: 5px;
					margin-bottom: 10px;
				}

				.info {
					display: flex;
					justify-content: space-between;
					font-size: 13px;
					color: #999;
					height: 30px;
					line-height: 30px;
				}

				.content {
					background: #fff;
					text-align: justify;

					span {
						line-height: 1.5;
						padding: 5px 0px;
						font-weight: bold;
					}

					p {
						line-height: 1.5;
						padding: 5px 0px;
					}
					
					a {
						text-decoration: none;
					}
				
					img {
						width: 100%!important;
						height: auto!important;
					}
				}
			}
		}

	}
</style>